import dispatcher from '../dispatcher';
import formComponentProto from '../form/form.component';
import addressStore from '../addressbar/addressbar.store';
import slideScrollStore from '../slide-scroll/slide-scroll.store';
import config from '../config';

var elementProto = Object.create(HTMLFormElement.prototype);

var _handleAddSlide = function(btn, slide) {
	var inner = slide.querySelector('.inner-hidden:not(.visible)');
	var addSlideLine = slide.getElementsByClassName('add-slide-line')[0];
	var cl = btn.getAttribute('data-class');
	var sibl = document.querySelector('.' + cl + '.hidden');
	var slideMode = slideScrollStore.getData().items['report-slides'].active;

	if (inner && addSlideLine) {
		setTimeout(function() {
			inner.classList.add('visible');
		}, 300);
		addSlideLine.classList.add('hidden');
		return;
	}

	if (!sibl) return;
	sibl.classList.remove('hidden');

	if (slideMode) {
		slide.style.pointerEvents = 'none';
		setTimeout(function() {
			dispatcher.dispatch({
				type: 'slide-scroll:direction',
				direction: 'down',
				id: 'report-slides'
			});
			slide.style.pointerEvents = 'auto';
		}, 300);
	}

	setTimeout(function() {
		btn.classList.add('hidden');
	}, 0);
}

var _initReport = function() {
	var self = this;

	Array.prototype.forEach.call(this._slides, function(slide, index) {
		var addButtons = slide.getElementsByClassName('add-slide');

		Array.prototype.forEach.call(addButtons, function(btn) {
			btn.addEventListener('click', self.handleAddSlide);
		});
	});
}

var _handleDispatcher = function(e) {
	var indicator;
	if (e.type === 'form-success' && e.id === this._id) {
		indicator = document.getElementsByClassName('indicator')[0];
		indicator.classList.add('hidden');
	}
}

elementProto.createdCallback = function() {
	formComponentProto.createdCallback.apply(this);

	this.initReport = _initReport.bind(this);
	this.handleAddSlide = _handleAddSlide.bind(this);
	this.handleDispatcher = _handleDispatcher.bind(this);
}
elementProto.attachedCallback = function() {
	var self = this;
	this._slides = document.getElementsByClassName('slide');

	formComponentProto.attachedCallback.apply(this);

	this._submitButton = this.getElementsByClassName('submit-button')[0];

	Array.prototype.forEach.call(this._slides, function(slide, index) {
		var addButtons = slide.getElementsByClassName('add-slide');

		Array.prototype.forEach.call(addButtons, function(btn) {
			btn.addEventListener('click', function(e) {
				e.preventDefault();
				self.handleAddSlide(btn, slide)
			});
		});
	});

	this._submitButton.addEventListener('click', function(e) {
		setTimeout(function() {
			dispatcher.dispatch({
				type: 'slide-scroll:handle-focus',
				id: 'report-slides'
			});
		}, 20);
	});

	dispatcher.subscribe(this.handleDispatcher);
}
elementProto.detachedCallback = function() {
	formComponentProto.detachedCallback.apply(this);
	dispatcher.unsubscribe(this.handleDispatcher);
}

document.registerElement('report-component', {
	prototype: elementProto,
	extends: 'form'
});